/** Sunday-first labels, matching the Search Date weekday row. */
export const FARE_MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const FARE_DATE_WEEK_LENGTH = 7;

/** Cheapest / mid / expensive fare text under a day. */
export const FARE_PRICE_COLOR_LOW = '#2e7d32';
export const FARE_PRICE_COLOR_MID = '#e67e00';
export const FARE_PRICE_COLOR_HIGH = '#d32f2f';
